import { cn } from '@/lib/utils'
import type {
  VehicleServicePlanSource,
  VehicleServicePlanStatus,
} from '@/modules/vehicles'
import { useTranslate } from '@ur-solutions/react-hooks'

const statusClassNames: Record<VehicleServicePlanStatus, string> = {
  PLANNED: 'border-sky-300 bg-sky-100 text-sky-900',
  BOOKED: 'border-indigo-300 bg-indigo-100 text-indigo-900',
  PERFORMED: 'border-emerald-300 bg-emerald-100 text-emerald-900',
  CANCELLED: 'border-stone-300 bg-stone-100 text-stone-700',
}

/** Status labels, also used for the filter's option labels. */
export function useServicePlanStatusLabels(): Record<
  VehicleServicePlanStatus,
  string
> {
  return useTranslate({
    PLANNED: 'vehicles.service.status.planned',
    BOOKED: 'vehicles.service.status.booked',
    PERFORMED: 'vehicles.service.status.performed',
    CANCELLED: 'vehicles.service.status.cancelled',
  })
}

/** Where the row came from. Only an integration source blocks editing. */
export function useServicePlanSourceLabels(): Record<
  VehicleServicePlanSource,
  string
> {
  return useTranslate({
    MANUAL: 'vehicles.service.source.manual',
    SCANIA: 'vehicles.service.source.scania',
  })
}

interface Props {
  status: VehicleServicePlanStatus
  className?: string
}

export const ServicePlanStatusBadge: React.FC<Props> = ({
  status,
  className,
}) => {
  const labels = useServicePlanStatusLabels()

  return (
    <span
      className={cn(
        'inline-flex items-center gap-2 rounded-full border px-3 py-1 text-xs font-semibold whitespace-nowrap',
        statusClassNames[status],
        className
      )}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current" />
      {labels[status]}
    </span>
  )
}
